'use client';

import { c as _c } from "react/compiler-runtime";
import SvgChevronleft from '@common/__generated__/icon/SvgChevronleft';
import SvgChevronright from '@common/__generated__/icon/SvgChevronright';
import { Button } from '@common/components';
import { cn } from '@core/utils';
import type { GiftOrderProductReviewDto } from '@generated/auth';
import useEmblaCarousel from 'embla-carousel-react';
import { useCallback, useEffect, useState } from 'react';
import { ReviewListItem } from './ReviewListItem';
interface ReviewShortcutSectionProps {
  items: GiftOrderProductReviewDto[];
  reviewCount?: number;
  className?: string;
}
export const ReviewShortcutSection = t0 => {
  const $ = _c(69);
  const {
    items,
    reviewCount,
    className
  } = t0;
  const [currentSlide, setCurrentSlide] = useState(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      align: "start"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [emblaRef, emblaApi] = useEmblaCarousel(t1);
  let t2;
  if ($[1] !== emblaApi) {
    t2 = () => {
      if (!emblaApi) {
        return;
      }
      setCurrentSlide(emblaApi.selectedScrollSnap());
    };
    $[1] = emblaApi;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const onSelect = t2;
  let t3;
  let t4;
  if ($[3] !== emblaApi || $[4] !== onSelect) {
    t3 = () => {
      if (!emblaApi) {
        return;
      }
      onSelect();
      emblaApi.on("select", onSelect);
      return () => {
        emblaApi.off("select", onSelect);
      };
    };
    t4 = [emblaApi, onSelect];
    $[3] = emblaApi;
    $[4] = onSelect;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  const chunkArray = _temp;
  let t10;
  let t11;
  let t12;
  let t13;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[7] !== className || $[8] !== currentSlide || $[9] !== emblaApi || $[10] !== emblaRef || $[11] !== items || $[12] !== reviewCount) {
    t13 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const chunkedList = chunkArray(items, 6);
      const isNotRender = items.length < 1;
      if (isNotRender) {
        t13 = null;
        break bb0;
      }
      t11 = className;
      let t14;
      if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = <div className="basis-100" />;
        $[22] = t14;
      } else {
        t14 = $[22];
      }
      let t15;
      if ($[23] !== reviewCount) {
        t15 = <h2 className="text-center font-700 text-Gray-900 typo-h6">현재 {reviewCount}명의 기부자들이 후기를 남겼어요!</h2>;
        $[23] = reviewCount;
        $[24] = t15;
      } else {
        t15 = $[24];
      }
      const t16 = currentSlide + 1;
      let t17;
      if ($[25] !== t16) {
        t17 = <span className="font-700 text-Gray-600">{t16}</span>;
        $[25] = t16;
        $[26] = t17;
      } else {
        t17 = $[26];
      }
      let t18;
      if ($[27] !== chunkedList || $[28] !== t17) {
        t18 = <p className="font-500 text-Gray-550 typo-body4">{t17} /{" "}{chunkedList.length}</p>;
        $[27] = chunkedList;
        $[28] = t17;
        $[29] = t18;
      } else {
        t18 = $[29];
      }
      let t19;
      if ($[30] !== emblaApi) {
        t19 = () => emblaApi?.scrollPrev();
        $[30] = emblaApi;
        $[31] = t19;
      } else {
        t19 = $[31];
      }
      let t20;
      if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t20 = <SvgChevronleft className="size-18 text-Gray-500" />;
        $[32] = t20;
      } else {
        t20 = $[32];
      }
      let t21;
      if ($[33] !== t19) {
        t21 = <Button theme="sub-line" className="size-24 rounded-[2px] bg-Gray-white p-0" onClick={t19}>{t20}</Button>;
        $[33] = t19;
        $[34] = t21;
      } else {
        t21 = $[34];
      }
      let t22;
      if ($[35] !== emblaApi) {
        t22 = () => emblaApi?.scrollNext();
        $[35] = emblaApi;
        $[36] = t22;
      } else {
        t22 = $[36];
      }
      let t23;
      if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t23 = <SvgChevronright className="size-18 text-Gray-500" />;
        $[37] = t23;
      } else {
        t23 = $[37];
      }
      let t24;
      if ($[38] !== t22) {
        t24 = <Button theme="sub-line" className="size-24 rounded-[2px] bg-Gray-white p-0" onClick={t22}>{t23}</Button>;
        $[38] = t22;
        $[39] = t24;
      } else {
        t24 = $[39];
      }
      let t25;
      if ($[40] !== t21 || $[41] !== t24) {
        t25 = <div className="flex">{t21}{t24}</div>;
        $[40] = t21;
        $[41] = t24;
        $[42] = t25;
      } else {
        t25 = $[42];
      }
      let t26;
      if ($[43] !== t18 || $[44] !== t25) {
        t26 = <div className="flex basis-100 items-center justify-end gap-8">{t18}{t25}</div>;
        $[43] = t18;
        $[44] = t25;
        $[45] = t26;
      } else {
        t26 = $[45];
      }
      if ($[46] !== t15 || $[47] !== t26) {
        t12 = <header className="mb-24 flex justify-between">{t14}{t15}{t26}</header>;
        $[46] = t15;
        $[47] = t26;
        $[48] = t12;
      } else {
        t12 = $[48];
      }
      if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
        t10 = cn("flex w-full justify-center rounded-large border-1 border-Gray-300 px-12 py-8");
        t9 = cn("flex flex-col items-center gap-24 content-container");
        t7 = cn("w-full overflow-hidden");
        $[49] = t10;
        $[50] = t7;
        $[51] = t9;
      } else {
        t10 = $[49];
        t7 = $[50];
        t9 = $[51];
      }
      t8 = emblaRef;
      t5 = "flex";
      t6 = chunkedList.map(_temp2);
    }
    $[7] = className;
    $[8] = currentSlide;
    $[9] = emblaApi;
    $[10] = emblaRef;
    $[11] = items;
    $[12] = reviewCount;
    $[13] = t10;
    $[14] = t11;
    $[15] = t12;
    $[16] = t13;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
    $[21] = t9;
  } else {
    t10 = $[13];
    t11 = $[14];
    t12 = $[15];
    t13 = $[16];
    t5 = $[17];
    t6 = $[18];
    t7 = $[19];
    t8 = $[20];
    t9 = $[21];
  }
  if (t13 !== Symbol.for("react.early_return_sentinel")) {
    return t13;
  }
  let t14;
  if ($[52] !== t5 || $[53] !== t6) {
    t14 = <div className={t5}>{t6}</div>;
    $[52] = t5;
    $[53] = t6;
    $[54] = t14;
  } else {
    t14 = $[54];
  }
  let t15;
  if ($[55] !== t14 || $[56] !== t7 || $[57] !== t8) {
    t15 = <div className={t7} ref={t8}>{t14}</div>;
    $[55] = t14;
    $[56] = t7;
    $[57] = t8;
    $[58] = t15;
  } else {
    t15 = $[58];
  }
  let t16;
  if ($[59] !== t15 || $[60] !== t9) {
    t16 = <div className={t9}>{t15}</div>;
    $[59] = t15;
    $[60] = t9;
    $[61] = t16;
  } else {
    t16 = $[61];
  }
  let t17;
  if ($[62] !== t10 || $[63] !== t16) {
    t17 = <div className={t10}>{t16}</div>;
    $[62] = t10;
    $[63] = t16;
    $[64] = t17;
  } else {
    t17 = $[64];
  }
  let t18;
  if ($[65] !== t11 || $[66] !== t12 || $[67] !== t17) {
    t18 = <section className={t11}>{t12}{t17}</section>;
    $[65] = t11;
    $[66] = t12;
    $[67] = t17;
    $[68] = t18;
  } else {
    t18 = $[68];
  }
  return t18;
};
function _temp(array, size) {
  const chunks = [];
  for (let i = 0; i < array.length; i = i + size, i) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
}
function _temp2(chunk, chunkIndex) {
  return <div key={chunkIndex} className="min-w-0 flex-[0_0_100%]"><div className={cn("grid grid-cols-3 gap-x-20 gap-y-16")}>{chunk.map((t0, index) => {
        const {
          reviewId: review_id,
          contents,
          productName: product_name,
          rating,
          fileUrlList: file_url_list
        } = t0;
        return <ReviewListItem key={`${chunkIndex}-${index}`} reviewId={review_id} productThumbnailUrl={file_url_list[0]} productName={product_name} rating={rating} reviewContent={contents} />;
      })}</div></div>;
}